import type {SectionSpacing} from '@/types/caseStudy';

/**
 * Builds a section's vertical-spacing className. Spacing maps to the global
 * service-page classes, applied conditionally so studies control the vertical
 * rhythm per section from the data file. Each direction pairs the desktop class
 * with its mobile override (both are global, defined in globals.scss), so
 * spacing is responsive automatically:
 *   top    → `top-space` (60px)    + `mobile-top-padding` (30px @ ≤600px)
 *   bottom → `bottom-spacing` (60px) + `mobile-bottom-padding` (30px @ ≤600px)
 * When `spacing` is undefined the section has NO vertical padding — studies opt
 * in per section via the data. The themed dark background is now applied via
 * `sx={csx.sectionDark}` (see caseStudyStyles), not here.
 */
export const sectionClass = (spacing: SectionSpacing | undefined): string => {
    const top = spacing === 'top' || spacing === 'both';
    const bottom = spacing === 'bottom' || spacing === 'both';
    return [top ? 'top-space mobile-top-padding' : '', bottom ? 'bottom-spacing mobile-bottom-padding' : ''].filter(Boolean).join(' ');
};
